<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_account_refundment"
        :columns="columns"
        :mod-count="modCount"
        :raw-data="mockData"
        :show-del="false"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-column-visible="true"
        :show-add="false"
      />
    </div>
  </div>
</template>

<script>
import TableWrapper from '@/components/table-wrapper'
export default {
  name: 'AccountRefundmentList',
  components: { TableWrapper },
  data() {
    return {
      url: this.$config.apiContextPath + '/account/refundment',
      modalForm: false,
      entityId: 0,
      modCount: 0
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '退款日期', width: '190px', options: {
            shortcuts: [
              {
                text: '一周',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                  return [start, end]
                }
              },
              {
                text: '一个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                  return [start, end]
                }
              },
              {
                text: '三个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                  return [start, end]
                }
              }
            ]
          }, placeholder: '请选择退款日期...', type: 'dateranger' },
          { label: '车库', placeholder: '请输入车库...', name: 'parking', width: 'auto', type: 'input' },
          { label: '用户', placeholder: '请输入用户姓名...', name: 'member', width: '100px', type: 'input' },
          { label: '手机号', placeholder: '请输入手机号...', name: 'mobile', width: '100px', type: 'input' },
          { label: '车辆编码', placeholder: '请输入编号...', name: 'planetNumber', width: '100px', type: 'input' },
          { label: '状态', placeholder: '请选择状态...', name: 'type', width: '100px', type: 'select', options: [
            { label: '已处理', value: 1 },
            { label: '待处理', value: 0 }
          ] }
        ]
      }
    },
    mockData() {
      return [
        {
          member: '张三',
          planetNumber: 'F000006057',
          mobile: '13612345678',
          parking: '远大中央公园1期',
          status: 1, // 0 -> 待返现, 1 -> 已返现
          refundTime: '2020-04-05 22:24', // 退款时间
          processTime: '2020-04-05 22:24', // 平台处理时间
          amount: 40.23,
          operator: '李四'
        },
        { member: '张三', planetNumber: 'F000006057', mobile: '13612345678', parking: '远大中央公园1期', status: 0, refundTime: '2020-04-05 22:24', processTime: '2020-04-05 22:24', amount: 122.03, operator: '李四' }
      ]
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center', key: '_index', disabled: true },
        { title: '车库', align: 'center', key: 'parking', sortable: true },
        { title: '车辆编码', align: 'center', key: 'planetNumber', sortable: true },
        { title: '车辆用户', align: 'center', key: 'member', sortable: true,
          render: (h, params) => {
            return h('span', {}, params.row.member || '---')
          }
        },
        { title: '用户手机号', align: 'center', key: 'mobile', sortable: true,
          render: (h, params) => {
            return h('span', {}, params.row.mobile || '---')
          }
        },
        { title: '退款金额', align: 'center', key: 'amount', sortable: true, width: 110, sum: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.amount > 0 ? '' : 'red' }
            }, params.row.amount)
          }
        },
        { title: '退款时间', align: 'center', sortable: true, key: 'refundTime', ellipsis: true, tooltip: true },
        { title: '处理时间', align: 'center', sortable: true, key: 'processTime', ellipsis: true, tooltip: true },
        { title: '状态', align: 'center', key: 'status', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.status === 1 ? '#28a745' : '#dc3545' }
            }, params.row.status === 1 ? '已返现' : '待返现')
          }
        },
        { title: '操作人员', align: 'center', sortable: true, key: 'operator', ellipsis: true, tooltip: true }
      ]
    }
  }
}
</script>
